var map = {
	"./de/resetpassword.json": 69724,
	"./en/resetpassword.json": 40216,
	"./es/resetpassword.json": 54475,
	"./fr/resetpassword.json": 50499,
	"./pt/resetpassword.json": 29951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26866;